export default "__VITE_ASSET__DRRT2MRx__"